"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountFlow = exports.NOSTRO_PROJECTION_BALANCE_TYPE_TRANSACTION = exports.NOSTRO_PROJECTION_BALANCE_TYPE_OPENING = exports.ACCOUNT_FLOW_TYPE_SWEEP_INSTRUCTION = exports.ACCOUNT_FLOW_TYPE_BALANCE = exports.ACCOUNT_FLOW_TYPE_PROJECTED = exports.ACCOUNT_FLOW_TYPE_AUTHORIZED_AND_ACTUAL = exports.ACCOUNT_FLOW_TYPE_ACTUAL = exports.ACCOUNT_FLOW_TYPE_AUTHORIZED = void 0;
exports.ACCOUNT_FLOW_TYPE_AUTHORIZED = 'AUTHORIZED';
exports.ACCOUNT_FLOW_TYPE_ACTUAL = 'ACTUAL';
exports.ACCOUNT_FLOW_TYPE_AUTHORIZED_AND_ACTUAL = 'AUTHORIZED_ACTUAL';
exports.ACCOUNT_FLOW_TYPE_PROJECTED = 'PROJECTED';
exports.ACCOUNT_FLOW_TYPE_BALANCE = 'BALANCE';
exports.ACCOUNT_FLOW_TYPE_SWEEP_INSTRUCTION = 'SWEEP_INSTRUCTION';
exports.NOSTRO_PROJECTION_BALANCE_TYPE_OPENING = 'OPENING';
exports.NOSTRO_PROJECTION_BALANCE_TYPE_TRANSACTION = 'TRANSACTION';
class AccountFlow {
    clone() {
        return Object.assign(new AccountFlow(), this);
    }
}
exports.AccountFlow = AccountFlow;
//# sourceMappingURL=account-flow.js.map